import { render, staticRenderFns } from "./request-partner-zone-component.vue?vue&type=template&id=97d207a8&"
import script from "./request-partner-zone-component.vue?vue&type=script&lang=js&"
export * from "./request-partner-zone-component.vue?vue&type=script&lang=js&"
import style0 from "./request-partner-zone-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports